import React, { memo } from 'react';
import { Col, Justify, Row } from 'tea-component';
import About from './components/About';
import News from './components/News';
import './index.scss';

interface AboutNewsPropsType {
  loading: boolean;
  headerData: Record<string, any>;
  aboutData: any;
  newsData: any;
  studioId: string;
}

const DEFAULT_PROPS: AboutNewsPropsType = {
  loading: false,
  headerData: null,
  aboutData: null,
  newsData: null,
  studioId: '',
};

function AboutNews(props: AboutNewsPropsType) {
  const { loading, headerData, aboutData, newsData, studioId } = props;

  return (
    <Row className="dbg-details-overview-about-news">
      <Col span={12}>
        <About loading={loading} data={aboutData} headerData={headerData} />
      </Col>
      <Col span={12}>
        <News loading={loading} data={newsData} studioId={studioId} />
      </Col>
    </Row>
  );
}

AboutNews.defaultProps = DEFAULT_PROPS;

export default memo(AboutNews);
